import { render, staticRenderFns } from "./AssetReferenceRegister.vue?vue&type=template&id=0d045b93"
import script from "./AssetReferenceRegister.vue?vue&type=script&lang=js"
export * from "./AssetReferenceRegister.vue?vue&type=script&lang=js"
import style0 from "./AssetReferenceRegister.vue?vue&type=style&index=0&id=0d045b93&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports